import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../common/Modal';

const PrintModal = ({
  isOpen,
  onClose,
  shippingAddress,
  onShippingAddressChange,
  onOrderPrint,
  onShowToast
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleOrder = () => {
    if (shippingAddress.trim()) {
      onOrderPrint();
      onClose();
    } else {
      onShowToast(t('editor.pleaseEnterAddress'));
    }
  };

  return (
    <Modal onClose={onClose} labelledBy="print-modal-title" panelClassName="p-4 sm:p-6">
      <h3 id="print-modal-title" className="text-2xl font-bold text-gray-900 mb-4">
        {t('editor.orderPhysicalPrint')}
      </h3>
      <p className="text-gray-600 mb-4">
        {t('editor.enterShippingAddress')}
      </p>
      <textarea
        value={shippingAddress}
        onChange={(e) => onShippingAddressChange(e.target.value)}
        placeholder={t('editor.shippingPlaceholder')}
        aria-label={t('editor.enterShippingAddress')}
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent resize-none"
        rows="5"
      />
      <div className="flex gap-3 mt-6">
        <button
          onClick={onClose}
          className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition"
        >
          {t('common.cancel')}
        </button>
        <button
          onClick={handleOrder}
          className="flex-1 px-4 py-2 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg hover:from-orange-600 hover:to-red-600 transition font-medium"
        >
          {t('editor.orderPrint')}
        </button>
      </div>
    </Modal>
  );
};

export default PrintModal;
